import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import "./Components/assets/vendor/aos/aos.css";
import "./Components/assets/vendor/bootstrap/css/bootstrap.min.css";
import "./Components/assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./Components/assets/vendor/glightbox/css/glightbox.min.css";
import "./Components/assets/vendor/remixicon/remixicon.css";
import "./Components/assets/vendor/swiper/swiper-bundle.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "@mdi/font/css/materialdesignicons.min.css";
import RegisterPage from "./Components/RegisterPage/RegisterPage";
import ChatPrice from "./Components/Pricing/ChatPrice";
import PopupPrice from "./Components/Pricing/PopupPrice";
import ReviewPrice from "./Components/Pricing/ReviewPrice";
import All from "./Components/Pricing/All";
import Login from "./Components/RegisterPage/Login";
import Subscribe from "./Components/ProductsRedirect/PopupSubscribe";
import Unsubscribe from "./Components/ProductsRedirect/PopupUnsubscribe";
import Products from "./Components/Products/Products";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import PopupGuide from "./Components/Guide-Video/PopupGuide";
import B2BPrice from "./Components/Pricing/B2BPrice";
import B2CPrice from "./Components/Pricing/B2CPrice";
import ValueProvider from "./Components/Context/SharedStateContext";
import EmailDashboard from "./Email/pages/Dashboard";
import Segment from "./Email/pages/segment";
import NewSegment from "./Email/pages/NewSegment";
import Temp from "./Email/pages/fileimage";
import Frontendapp from "./Email/pages/frontend";
import NewCampaign from "./Email/pages/NewCampaign";
import Campaign from "./Email/pages/Campaign";
import LaunchCampaignBuilder from "./Email/pages/CampaignBuilder";
import Email from "./Email/pages/Email";
import Assets from "./Email/pages/Assets";
import Components from "./Email/pages/Components";
import AssetDashboard from "./Email/pages/assetdashboard";
import Contact from "./Email/pages/contactpage";
import Forms from "./Email/pages/Forms";
import ContentGrid from "./Email/pages/Dynamicgrid";
import Components2 from "./Email/pages/formgrid";
import Content from "./Email/pages/Dynamiccontent";
import Dashboard from "./Chat/Components/Pages/Dashboard";
import MyProvider from "./Chat/Components/Context/SharedStateContext";
import UnassignedNew from "./Chat/Components/Inbox/UnassignedNew";
import MyopenNew from "./Chat/Components/Inbox/MyOpenNew";
import SolvedNew from "./Chat/Components/Inbox/SolvedNew";
import FAQPage from "./Chat/Components/Pages/FAQPage";
import ChatContact from "./Chat/Components/Pages/Contact";
import ChatIcon from "./Chat/Components/Setting/Chaticon";
import DisplayRule from "./Chat/Components/Setting/DisplayRule";
import OperatingHour from "./Chat/Components/Setting/OperatingHour";
import Tickets from "./Chat/Components/Ticket/Tickets";
import Home from "./Epic-X/pages/Home";
import AboutUs from "./Epic-X/pages/AboutUs";
import PopupProduct from "./Epic-X/pages/PopupProduct";
import ChatProduct from "./Epic-X/pages/ChatProduct";
import B2BProduct from "./Epic-X/pages/B2BProduct";
import B2CProduct from "./Epic-X/pages/B2CProduct";
import AIEmailProduct from "./Epic-X/pages/AIEmailProduct";
import HydraTrackProduct from "./Epic-X/pages/HydraTrackProduct";
import ServicesPage from "./Epic-X/pages/ServicePage";
import PricingPage from "./Epic-X/pages/PricingPage";
import ContactPage from "./Epic-X/pages/ContactPage";
import AIB2C from "./Epic-X/pages/Features/AIB2C";
import SmartB2B from "./Epic-X/pages/Features/SmartB2B";
import AIChat from "./Epic-X/pages/Features/AIChat";
import AIPopup from "./Epic-X/pages/Features/AIPopup";
import ECommerceAIPage from "./Epic-X/pages/AI-Driven/ECommerceAIPage";
import AIPayment from "./Epic-X/pages/AI-Driven/AIPayment";
import AIApiIntegration from "./Epic-X/pages/AI-Driven/AIApiIntegration";
import PostLaunchSupport from "./Epic-X/pages/AI-Driven/PostLaunchSupport";
import Clients from "./Epic-X/pages/Clients";
import ConsultantProfile from "./Epic-X/pages/ConsultantProfile";
import ResetPassword from "./Components/RegisterPage/ResetPassword";
import ChatGuide from "./Components/Guide-Video/ChatGuide";
import ReviewGuide from "./Components/Guide-Video/ReviewGuide";
import VerifyReview from "./Components/ProductsRedirect/ReviewVerification";

AOS.init();

function App() {
  const tenantName = localStorage.getItem("tenantName");
  useEffect(() => {
    const aosInit = () => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    };
    aosInit();
    return () => {
      AOS.refresh(); // Refresh AOS to remove any animations
    };
  }, []);
  return (
    <ValueProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* <Route
              path="/"
              element={
                <>
                  <Header />
                  <MainContent />
                  <Footer />
                </>
              }
            />  */}
            <Route path="/" element={<Home />} />
            <Route path="/About-Us" element={<AboutUs />} />
            <Route path="/product/popup" element={<PopupProduct />} />
            <Route path="/product/chat" element={<ChatProduct />} />
            <Route path="/product/B2B" element={<B2BProduct />} />
            <Route path="/product/B2C" element={<B2CProduct />} />
            <Route path="/product/Email" element={<AIEmailProduct />} />
            <Route path="/product/HydraTrack" element={<HydraTrackProduct />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/product/pricing" element={<PricingPage />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/consultant" element={<ConsultantProfile />} />
            <Route path="/contact-us" element={<ContactPage />} />

            <Route path="/Features/B2C" element={<AIB2C />} />
            <Route path="/Features/B2B" element={<SmartB2B />} />
            <Route path="/Features/Chat" element={<AIChat />} />
            <Route path="/Features/Popup" element={<AIPopup />} />

            <Route path="/ai-driven/E-Commerce" element={<ECommerceAIPage />} />
            <Route path="/ai-driven/ai-payment" element={<AIPayment />} />
            <Route
              path="/ai-driven/ai-api-integration"
              element={<AIApiIntegration />}
            />
            <Route
              path="/ai-driven/post-launch-support"
              element={<PostLaunchSupport />}
            />

            <Route path="/ChatPrice" element={<ChatPrice />} />
            <Route path="/PopupPrice" element={<PopupPrice />} />
            <Route path="/ReviewPrice" element={<ReviewPrice />} />
            <Route path="/b2bPrice" element={<B2BPrice />} />
            <Route path="/b2cPrice" element={<B2CPrice />} />
            <Route path="/All" element={<All />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/Register" element={<RegisterPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/confirm-password" element={<ResetPassword />} />
            <Route path="/:clientname/products" element={<Products />} />
            <Route path="/api/subscribe" element={<Subscribe />} />
            <Route path="/api/unsubscribe" element={<Unsubscribe />} />
            <Route path="/popup-guide" element={<PopupGuide />} />
            <Route path="/chat-guide" element={<ChatGuide />} />
            <Route path="/review-guide" element={<ReviewGuide />} />
            <Route path="/review/thank-you" element={<VerifyReview />} />
          </Routes>

          <Routes>
            {/* Email Campaign */}
            <Route
              path=":tenantName/email/dashboard"
              element={<EmailDashboard />}
            />
            <Route path=":tenantName/email/segment" element={<Segment />} />
            <Route
              path=":tenantName/email/newsegment"
              element={<NewSegment />}
            />
            <Route path=":tenantName/email/fileimage" element={<Temp />} />
            <Route
              path=":tenantName/email/frontend"
              element={<Frontendapp />}
            />
            <Route
              path=":tenantName/email/newcampaign"
              element={<NewCampaign />}
            />
            <Route path=":tenantName/email/campaigns" element={<Campaign />} />
            <Route
              path=":tenantName/email/campaignbuilder"
              element={<LaunchCampaignBuilder />}
            />
            <Route path=":tenantName/email/email" element={<Email />} />
            <Route path=":tenantName/email/assets" element={<Assets />} />
            <Route
              path=":tenantName/email/components"
              element={<Components />}
            />
            <Route
              path=":tenantName/email/assetdashboard/:id"
              element={<AssetDashboard />}
            />
            <Route path=":tenantName/email/contact" element={<Contact />} />
            <Route path=":tenantName/email/form" element={<Forms />} />
            <Route
              path=":tenantName/email/ContentGrid"
              element={<ContentGrid />}
            />
            <Route
              path=":tenantName/email/formgridpath"
              element={<Components2 />}
            />
            <Route
              path=":tenantName/email/dynamic-content"
              element={<Content />}
            />
          </Routes>

          {/* Chat Routes */}
          <MyProvider>
            <Routes>
              <Route
                path=":tenantName/chat/dashboard"
                element={<Dashboard />}
              />
              <Route
                path=":tenantName/chat/Conversation/Unassigned/:collection"
                element={<UnassignedNew />}
              />
              <Route
                path=":tenantName/chat/Conversation/MyOpen/:collection"
                element={<MyopenNew />}
              />
              <Route
                path=":tenantName/chat/Conversation/Solved/:collection"
                element={<SolvedNew />}
              />
              <Route path=":tenantName/chat/tickets" element={<Tickets />} />
              <Route path=":tenantName/chat/faq-bot" element={<FAQPage />} />
              <Route
                path=":tenantName/chat/contact"
                element={<ChatContact />}
              />
              <Route
                path=":tenantName/chat/Setting/Appearance"
                element={<ChatIcon />}
              />
              <Route
                path=":tenantName/chat/Setting/displayrules"
                element={<DisplayRule />}
              />
              <Route
                path=":tenantName/chat/Setting/operating-hour"
                element={<OperatingHour />}
              />
            </Routes>
          </MyProvider>
        </BrowserRouter>
      </div>
    </ValueProvider>
  );
}

export default App;
